<template>
  <div
    class="classification-list-wrap"
    :class="{active:classificationListActive}"
  >
    <div class="classification-list">
      <div
        class="classification-list_content"
        :class="{active:classificationListActive}"
      >
        <div class="classification-list_content-select">
          <div class="classification-list-title">
            {{ $t(title) }}
          </div>
          <div v-if="classificationList && classificationList.length > 0">
            <LvSelectCheckboxList
              v-for="(class_e,class_k) in classificationList"
              :key="class_k"
              v-model="systemClassSelectSubmit"
              :title="class_e.name"
              :checkboxes="class_e.system_subclasses"
              class="mt-20"
            />
          </div>
          <LvText h5 lightGray class="mt-20">{{ $t('無選項') }}</LvText>
        </div>
        <div
          v-if="classificationList && classificationList.length > 0"
          class="action-buttons"
        >
          <WsTextButton001 @click="$_myMethodsselectSystemCancel()">
            {{ cancelBtn }}
          </WsTextButton001>
          <WsTextButton001
            :primary="!$_arrayAreEqual(systemClassSelectSubmit,_allSelect)"
            @click="selectSystemSubmit()"
          >
            {{ submitBtn }}
          </WsTextButton001>
        </div>
      </div>
      <div
        v-if="classificationListActive"
        class="tablet-bg"
        @click="classificationListClose()"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlShowClassificationList",
  props: {
    classificationList: {
      type: Array,
      default() {
        return [];
      },
    },
    classificationListActive: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "",
    },
    submitBtn: {
      type: String,
      default() {
        return this.$t("套用");
      },
    },
    cancelBtn: {
      type: String,
      default() {
        return this.$t("取消");
      },
    },
  },
  data: () => ({
    systemClassSelectSubmit: [],
  }),
  computed: {
    _allSelect() {
      let allSelect = [];
      this.classificationList.forEach((classification) => {
        classification.system_subclasses.forEach((system) => {
          allSelect.push(system.id);
        });
      });
      return allSelect;
    },
  },
  watch: {
    value() {
      this.systemClassSelectSubmit = this.value;
    },
  },
  mounted() {
    this.systemClassSelectSubmit = this.value;
  },
  methods: {
    classificationListClose() {
      this.$emit("click");
    },
    $_myMethodsselectSystemCancel() {
      this.systemClassSelectSubmit = this._allSelect;
      this.$emit("input", this.systemClassSelectSubmit);
      this.$emit("search");
      this.classificationListClose();
    },
    selectSystemSubmit() {
      if (this.$_arrayAreEqual(this.systemClassSelectSubmit, this._allSelect)) {
        return;
      }
      this.$emit("input", this.systemClassSelectSubmit);
      this.$emit("search");
      this.$emit("click");
    },
    $_arrayAreEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;
      for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/classification-list";
</style>